<template>
  <div class="modal fade" id="edit-source-modal">
    <div class="modal-dialog modal-dialog-centered modal-fullscreen-md-down">
      <div class="modal-content border-0">
        <div class="modal-header border-0 pb-0">
           <div class="d-flex align-items-center gap-3">
              <button type="button" class="btn-close-mob d-md-none" data-bs-dismiss="modal">
                 <vue-feather type="x" size="20"></vue-feather>
              </button>
              <h5 class="fw-bold mb-0">Edit Sumber Produk</h5>
           </div>
           <button type="button" class="btn-close d-none d-md-block" data-bs-dismiss="modal" ref="closeBtn"></button>
        </div>
        <div class="modal-body p-4">
           <form @submit.prevent="handleSave">
              <div class="mb-4">
                 <label class="form-label">Nama Sumber</label>
                 <input type="text" v-model="form.nama_sumber" class="form-control" required />
              </div>
              <div class="mb-4">
                 <label class="form-label">Status</label>
                 <vue-select
                    :options="statusOptions"
                    v-model="form.status"
                    id="edit-source-status"
                    placeholder="Pilih Status"
                 />
              </div>
              <div class="d-grid mt-4">
                 <button type="submit" class="btn btn-dark rounded-pill py-3 fw-bold shadow-sm" :disabled="loading">
                    {{ loading ? 'MENYIMPAN...' : 'SIMPAN PERUBAHAN' }}
                 </button>
              </div>
           </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.btn-close-mob {
    background: #f8fafc;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
}

.form-label {
    font-size: 11px;
    font-weight: 800;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.form-control {
    border: 1px solid #f1f5f9;
    background: #f8fafc;
    border-radius: 12px;
    padding: 14px 16px;
    font-size: 14px;
}
.form-control:focus {
    border-color: #029147;
    background: white;
    box-shadow: none;
}
</style>

<script>
import { reactive, watch, ref } from 'vue';
import sourceService from '@/services/sourceService';
import { useDataStore } from '@/store/dataStore';
import Swal from 'sweetalert2';

export default {
  props: {
    source: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const { refreshData } = useDataStore();
    const loading = ref(false);
    const closeBtn = ref(null);
    
    const form = reactive({
      nama_sumber: '',
      status: 'active'
    });

    const statusOptions = [
      { id: 'active', text: 'Aktif' },
      { id: 'inactive', text: 'Non-Aktif' }
    ];

    watch(() => props.source, (newVal) => {
      if (newVal && newVal.id) {
        form.nama_sumber = newVal.nama_sumber;
        form.status = newVal.status;
      }
    }, { immediate: true });

    const handleSave = async () => {
      if (!props.source.id) return;
      
      loading.value = true;
      try {
        await sourceService.updateSource(props.source.id, {
          nama_sumber: form.nama_sumber,
          status: form.status
        });

        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });

        Toast.fire({
          icon: 'success',
          title: 'Sumber berhasil diperbarui'
        });

        await refreshData('sources');
        
        if (closeBtn.value) {
          closeBtn.value.click();
        }
      } catch (error) {
        console.error("Update error:", error);
        Swal.fire({
          icon: 'error',
          title: 'Gagal memperbarui sumber'
        });
      } finally {
        loading.value = false;
      }
    };

    return {
      form,
      statusOptions,
      loading,
      handleSave,
      closeBtn
    };
  }
};
</script>
